'use es6';

import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NOT_SPECIFIED, READ_ONLY, HIDDEN } from 'customer-data-sidebar/fieldLevelPermissions/PermissionTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const FieldLevelPermissionTooltip = ({
  fieldLevelAccess,
  children
}) => {
  if (fieldLevelAccess === NOT_SPECIFIED) {
    return children;
  }
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      disabled: false,
      "data-unit-test": "field-level-permission-tooltip",
      "data-test-id": "field-level-permission-tooltip",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "universalSidebar.permissions.READ_ONLY"
      }),
      children: /*#__PURE__*/_jsx("span", {
        children: children
      })
    })
  });
};
FieldLevelPermissionTooltip.propTypes = {
  fieldLevelAccess: PropTypes.oneOf([NOT_SPECIFIED, READ_ONLY, HIDDEN]),
  children: PropTypes.node.isRequired
};
export default FieldLevelPermissionTooltip;